import React from 'react'
import { useMedia } from 'sb-hooks'
import cx from 'classnames'
import { useFieldState, Form } from 'formular'
import { Modal, ModalVisibilityProps } from 'sb-modal'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'
import SelectableReasonField from 'compositions/form/SelectableReasonField/SelectableReasonField'
import { ContentWithLoader } from 'components/_new/ui'

import messages from './messages'
import s from './UnsubscribeReasonModalView.scss'


type UnsubscribeReasonModalViewProps = Pick<ModalVisibilityProps, 'onClose'> & {
  form: Form<UnsubscribeReasonModal.FormValues>
  reasons: UnsubscribeReasonModal.Reason[]
  isFetching: boolean
  onSubmit: () => void
}

const UnsubscribeReasonModalView: React.FunctionComponent<UnsubscribeReasonModalViewProps> = (props) => {
  const {
    reasons, form, isFetching, onSubmit, onClose,
  } = props

  const { isMobile } = useMedia()

  const { value: reason } = useFieldState(form.fields.reason)

  return (
    <Modal
      className={cx('humbleBgColor', s.modal)}
      title={messages.title}
      text={messages.text}
      primaryButton={{
        title: messages.submitButton,
        rightIcon: 'rightArrowSmall',
        centering: !isMobile,
        disabled: !reason,
        onClick: onSubmit,
      }}
      ordinaryButton={{
        title: messages.nevermindButton,
        onClick: onClose,
      }}
      onClose={onClose}
      dataTestId="reasonModal"
    >
      <div className={s.header}>
        <Box className={s.founders} pt={4} alignCenter>
          <Text message={messages.founders} size="12-16" />
        </Box>
      </div>
      <Box mt={32}>
        <ContentWithLoader isFetching={isFetching}>
          {
            Boolean(reasons) && reasons.map(({ value, title }, index) => (
              <Box key={index} mt={index > 0 ? 16 : null}>
                <SelectableReasonField
                  type="radio"
                  title={title}
                  value={value}
                  checkedField={form.fields.reason}
                  commentsField={form.fields.comments}
                  dataTestId="unsubscribeReason"
                />
              </Box>
            ))
          }
        </ContentWithLoader>
      </Box>
    </Modal>
  )
}


export default UnsubscribeReasonModalView
